import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { logout } from "actions/auth";
import Form from "./components/Form";
import LogoDefault from "components/Logo";
import background from "assets/images/login_background_blue.png";

import styles from "./ResetPassword.module.scss";

const ResetPassword = ({ title }) => {
  const params = useParams();
  const { uid, token } = params;
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(logout());
  }, [dispatch]);

  return (
    <section className={styles.section}>
      <img src={background} alt="background" className={styles.background} />
      <div className="container">
        <LogoDefault className={styles.logo} />
        <Form uid={uid} token={token} title={title} />
      </div>
    </section>
  );
};

export default ResetPassword;
